import React from 'react';
import { DefaultStages } from '@shared/types/frontend';
import { NormieDataRow, NormieHeaderRow, NormieRowType } from '@shared/types/frontend/tables';
import ImageWithFallback from '@/components/shared/ImageWithFallback';
import Loading from '@/components/shared/Loading';
import LaunchPadView from '@/components/explore/LaunchPadView';
import NormieTable from './NormieTable';
import DFiltersController from '../filters/DFiltersController';
import FilterMemeMode from '../filters/FilterMemeMode';
import { useSearchHome } from '@/contexts/SearchHomeProvider';
import FilterByTokenType from '../filters/FilterByTokenType';
import TopTokensResults from './TopTokensResults';
import DTCashResults from './DTCashResults';
import useAppSettings, { AppConfigKeys } from '@/hooks/admin/useAppSettings';
const NormieController = () => {
  const {
    setKeyword,
    network,
    setNetwork,
    timeFrame,
    setTimeFrame,
    defaultNetwork,
    subMode,
    setSubMode,
    subMemeData,
    resultsToUse,
    useUnprotectedSearch,
    setUseUnprotectedSearch,
    mode,
    setMode,
    stage,
    allTokens,
    allTokensLoading
  } = useSearchHome();
  const prepareTableData = (mode: string, subMode: string, resultsToUse: any[], allTokens?: any[], allTokensLoading?: boolean): (NormieHeaderRow | NormieDataRow)[] => {
    if (!resultsToUse) return [];
    if (mode === 'memes' && subMode === 'Trending') {
      const recentlyListed = resultsToUse[0] ? [resultsToUse[0]] : [];
      const trending = resultsToUse.slice(1) || [];
      return [{
        type: NormieRowType.HEADER,
        content: 'Recently Listed',
        className: 'text-[20px] text-genius-gradient ml-4 py-2',
        height: 42
      }, ...recentlyListed, {
        type: NormieRowType.HEADER,
        content: 'Trending',
        className: 'text-[20px] text-genius-gradient ml-4 py-2',
        height: 42
      }, ...trending];
    }
    if (mode === 'search') {
      return [{
        type: NormieRowType.HEADER,
        content: 'Search Results',
        className: 'ml-4 text-2xl text-genius-cream',
        height: 34
      }, ...resultsToUse];
    }
    if (mode === 'recent') {
      return [{
        type: NormieRowType.HEADER,
        content: 'Recent Items',
        className: 'ml-4 text-2xl text-genius-cream',
        height: 34
      }, ...resultsToUse];
    }
    if (mode === 'top' && allTokens) {
      return [{
        type: NormieRowType.HEADER,
        content: 'Top 10',
        className: 'text-[20px] pl-4 py-3 gradient-genius-sides',
        height: 54
      }, ...resultsToUse.map(item => ({
        ...item,
        isTop: true
      })), ...(allTokensLoading ? [{
        type: NormieRowType.HEADER,
        content: 'Loading All Tokens...',
        className: 'text-genius-gradient text-[20px] pl-4 my-6',
        height: 54
      }] : []), ...(allTokens ? [{
        type: NormieRowType.HEADER,
        content: 'All',
        className: 'text-[20px] pl-4 py-3 gradient-genius-sides',
        height: 54
      }, ...allTokens] : [])];
    }
    return resultsToUse;
  };
  const {
    appConfig
  } = useAppSettings();
  return <div className='flex flex-col h-full genius-shadow rounded-[20px] no-scrollbar' data-sentry-component="NormieController" data-sentry-source-file="NormieController.tsx">
      <div className='flex-1 flex flex-col bg-genius-indigo rounded-[20px] pt-2 border border-genius-blue overflow-hidden'>
        <div className='flex justify-between pl-4 pr-2 my-2'>
          <FilterByTokenType setKeyword={setKeyword} mode={mode} setMode={setMode} customHandler data-sentry-element="FilterByTokenType" data-sentry-source-file="NormieController.tsx" />
          <div className='items-center flex'>
            <DFiltersController network={network} defaultNetwork={defaultNetwork} setNetwork={setNetwork} timeFrame={timeFrame} setTimeFrame={setTimeFrame} customHandler data-sentry-element="DFiltersController" data-sentry-source-file="NormieController.tsx" />
          </div>
        </div>
        <div className='flex-1 flex flex-col'>
          {mode === 'cash' ? <DTCashResults onTokenClick={undefined} /> : mode === 'native' ? <TopTokensResults mode={mode} resultsToUse={resultsToUse()} timeFrame={timeFrame} /> : mode == 'launchpad' ? <LaunchPadView /> : <>
              {mode === 'memes' && <>
                  <FilterMemeMode setMode={setMode} subMode={subMode} setSubMode={setSubMode} timeFrame={timeFrame} subMemeData={subMemeData} network={network} />
                </>}
              {subMode === 'Trending' && mode === 'memes' && appConfig?.[AppConfigKeys.alertMessage] && <>
                    <div className='px-4 text-[12px] my-2  text-genius-cream p-4 border-red-400 border-[1px] rounded-[20px] bg-[#F8717126] mx-4'>
                      {appConfig?.[AppConfigKeys.alertMessage]}
                    </div>
                  </>}

              {(mode === 'hot' || mode === 'gainers' || mode === 'new') && <div className='m-4 mt-2 p-2 text-xs text-genius-cream bg-red-500 bg-opacity-10 border-red-400 border-[1px] rounded-lg'>
                  Tokens here are algorithmically sourced from on-chain data. They are not vetted
                  for honeypots or scams. Genius is not responsible for lost funds. Exercise caution
                  when trading.
                </div>}
              {stage === DefaultStages.loading ? <div className={'w-full flex items-center flex-col justify-center'} style={{
            height: mode === 'memes' ? '32vh' : '52vh'
          }}>
                  <Loading />
                </div> : stage === DefaultStages.results ? <NormieTable key={`${mode}-${subMode}-${timeFrame}`} resultsToUse={prepareTableData(mode, subMode, mode === 'memes' && subMode === 'Trending' || mode === 'top' ? resultsToUse() : resultsToUse()?.sort((a, b) => parseFloat(b?.['volume' + timeFrame]) - parseFloat(a?.['volume' + timeFrame])), mode === 'top' ? allTokens : undefined, mode === 'top' ? allTokensLoading : undefined)} setKeyword={setKeyword} timeFrame={timeFrame} /> : stage == DefaultStages.noResults ? <div className='text-genius-cream/50 mx-auto justify-center ta-c text-base flex items-center mt-[150px] flex-col'>
                  <ImageWithFallback src='/static/icons/nothingcircle.png' width={80} height={80} alt='nothing here' className='my-8' />
                  {mode === 'search' ? 'No Safe Search Results' : mode === 'new' ? 'No New Tokens in the last 24 hours' : mode == 'saved' ? 'No Saved Tokens' : <div>
                      <Loading />
                    </div>}
                  {mode === 'search' && !useUnprotectedSearch && <div className='bg-genius-blue rounded-full p-2 px-4 text-genius-cream mt-4 text-[12px]' onClick={() => {
              setUseUnprotectedSearch(true);
            }}>
                      Show Low Volume Results
                    </div>}
                </div> : null}
            </>}
        </div>
      </div>
    </div>;
};
export default NormieController;